export default "data:image/jpeg;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAic3RhdGljL21lZGlhL2luZGlhbl9jYXNpbm9fMi44OWU5OTIzMS5qcGciOw=="